<template>
  <roe-error-message
    :field="design.employee_contrib_plan_uses_autoenroll_picklist_id"
  >
    <v-select
      v-model="design.$model.employee_contrib_plan_uses_autoenroll_picklist_id"
      :options="selectOptions.auto_enrollment_plan"
      :reduce="label => label.code"
      @input="onChange"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import {
  AutoEnrollmentMixin,
  ResetDesignAttributesMixin
} from "@/components/_shared/inputs/design/_mixins";
import { mapGetters } from "vuex";
export default {
  name: "RoeAutoEnrollmentSelect",
  components: { RoeErrorMessage },
  mixins: [AutoEnrollmentMixin, ResetDesignAttributesMixin],
  props: {
    design: Object
  },
  computed: {
    ...mapGetters(["selectOptions"])
  },
  methods: {
    onChange() {
      this.resetAttributes(
        this.design,
        "employee_contrib_plan_uses_autoenroll_picklist_id"
      );
    }
  }
};
</script>
